<template>
  <v-card flat tile>
    <v-card-title>
      Documents
      <v-spacer />
      <v-text-field
        v-model="searchDocuments"
        clearable
        flat
        hide-details
        label="Search"
        :prepend-icon="icons.search"
        single-line
        solo-inverted
      />
      <v-btn depressed class="ml-2" @click="createItem()">
        Add Document
      </v-btn>
    </v-card-title>
    <v-divider />
    <v-data-table
      v-model="selected"
      :items="documents"
      :headers="documentHeaders"
      :search="searchDocuments"
      show-select
    >
      <template v-slot:item="{ item }">
        <td>
          <v-checkbox v-model="item.selected" primary hide-details />
        </td>
        <td>{{ item.name }}</td>
        <td>{{ item.originalName }}</td>
        <td>{{ item.archive.bool }}</td>
        <!--
        ...
      -->
        <td>
          <v-chip label dense>
            {{ item.archive.type }}
          </v-chip>
        </td>
        <td>
          <v-chip v-for="slide in item.slides" :key="slide._id" label dense>
            {{ slide.name }}
          </v-chip>
        </td>
        <td class="justify-center layout px-0">
          <v-icon small class="mr-2" @click="editItem(item)">
            {{ icons.edit }}
          </v-icon>
          <v-icon small @click="deleteItem(item)">
            {{ icons.trash.toTrash }}
          </v-icon>
        </td>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import { mapState } from 'vuex';
import {
  DOCUMENTS_TABLE_HEADERS,
  GET_DOCUMENTS,
  SHOW_DOCUMENT_MODAL,
  DELETE_DOCUMENT
} from '@/config/constants';
import icons from '../../mixins/icons';
import { DocumentsService } from '../../services/modules/documents';

export default {
  mixins: [icons],
  data() {
    return {
      selected: [],
      search: null,
      documentHeaders: DOCUMENTS_TABLE_HEADERS,
      searchDocuments: ''
    };
  },
  watch: {
    selected() {
      this.$emit('selected', this.selected);
    }
  },
  async created() {
    await this.$store.dispatch(GET_DOCUMENTS);
  },
  computed: {
    ...mapState('documents', {
      documents: state => {
        var items = state.documents.items;
        return Array.isArray(items) ? items : [];
      }
    })
  },
  methods: {
    createItem() {
      this.$store.dispatch(SHOW_DOCUMENT_MODAL);
    },
    editItem(item) {
      this.$store.dispatch(SHOW_DOCUMENT_MODAL, item);
    },
    deleteItem(item) {
      confirm(
        'Document löschen',
        `Möchtest du das Document "${item.name}" wirklich löschen?`,
        'Ja',
        'Nein'
      ).then(yes => {
        if (yes) {
          this.$store.dispatch(DELETE_DOCUMENT, item);
        }
      });
    },
    async downloadItem(item) {
      await new DocumentsService().download(item, `${item.originalName}`).then(link => {
        if (link) {
          link.click();
        } else {
          // TODO: error message
        }
      });
    },
    //
    onSelect(selected) {
      this.selected = selected;
      this.$emit('selected', selected);
    },
    formatTime(time) {
      return moment(time).format('DD.MM.YY kk:mm');
    }
  }
};
</script>

<!--
<documents-table
  :items="if_there_are_other_documents_eg_for_slide_detail_view"
  :selectable="true"
  @selected="getSelectedDocuments"
>
  <slot name="actions">
    <v-icon
      small
      class="mr-2"
      @click="editItem(props.item)"
    >
      edit
    </v-icon>
    <v-icon
      small
      @click="deleteItem(props.item)"
    >
      delete
    </v-icon>
  </slot>
</documents-table>
-->
